<ng-container #prefix></ng-container>
<div class="label">
  <rt-icon [name]="iconName" [size]="iconSize"> </rt-icon>
</div>
<ng-container #suffix></ng-container>
